import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import RouteService from "../../../../services/catalogs/RouteService";

export const REQUEST_FETCH_ROUTE = "REQUEST_FETCH_ROUTE";
export const FETCH_ROUTE_SUCCESS = "FETCH_ROUTE_SUCCESS";
export const FETCH_ROUTE_ERROR = "FETCH_ROUTE_ERROR";
export const INITIAL_STATE_ROUTE = "INITIAL_STATE_ROUTE";

function requestFetchRoute() {
  return {
    type: REQUEST_FETCH_ROUTE,
  };
}

function fetchRouteSuccess(json) {
  return {
    type: FETCH_ROUTE_SUCCESS,
    route: json.data,
  };
}

function fetchRouteError(json) {
  return {
    type: FETCH_ROUTE_ERROR,
    error: json.data,
  };
}

export function initialStateRoute() {
  return {
    type: INITIAL_STATE_ROUTE,
  };
}

export function fetchRoute(route_id) {
  return (dispatch) => {
    dispatch(requestFetchRoute());
    return RouteService.getRoute(route_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchRouteSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchRoute(route_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchRouteError(json.data));
      }
    });
  };
}
